define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/LocalizationUtil',
	'internal_util/Configuration',
	'model/Error',
	'model/ErrorType',
	'model/Attribute',
	'model/RequestedAttribute',
	'service/EventListenerRegistry',
	'amdi18n-loader?!service/nls/AttributesManager_strings',
	'lib/jquery'
], function (
	Logger,
	Util,
	LocalizationUtil,
	Configuration,
	Error,
	ErrorType,
	Attribute,
	RequestedAttribute,
	EventListenerRegistry,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * AttributesManager class
	 */
	return function () {
		var _attributeDefinitions = new Array(),
			_attributeOrder = [
								'FirstName',
								'LastName',
								'CommonName',
								'AcademicTitle',
								'Age',
								'AgeVerification',
								'Gender',
								'Nationality',
								'DateOfBirth',
								'PlaceOfBirth',
								'Street',
								'StreetNumber',
								'ZipCode',
								'City',
								'State',
								'Country',
								'Organization',
								'OrganizationUnit',
								'Email',
								'Phone',
								'Profile-URI',
								'Website-URI',
								'Document',
								'IDIssuer',
								'IDNumber',
								'IDType',
								'IDAuthProtocol',
								'IssuingState',
								'eIdentifier'
							];


		// private methods

		function log(method, message, data) {
			Logger.log('AttributesManager', method, message, data);
		}

		function callLog(method, message, data, event, callbacks) {
			log(method, message, data);
			EventListenerRegistry.callListeners(event, data, function () {
				Util.callCallbacks(callbacks, data);
			});
		}

		function getAttribute(attributeId) {
			for (var i = 0; i < _attributeDefinitions.length; i++) {
				if (_attributeDefinitions[i]['URI'].indexOf(attributeId) !== -1) {
					return _attributeDefinitions[i];
				}
			}

			return null;
		}


		// public methods

		this.getAttributeDefinitions = function (callbacks, errorCallbacks) {
			var _name = 'getAttributeDefinitions',
				attributeDefinitionsURL = Configuration.get('ATTRIBUTE_DEFINITIONS_URL'),
				locale = LocalizationUtil.getShortLocale();

			attributeDefinitionsURL = attributeDefinitionsURL.replace(/LANG/g, locale.toUpperCase());

			callLog(_name, Strings.get_attribute_definitions_started, attributeDefinitionsURL, 'GET_ATTRIBUTE_DEFINITIONS_STARTED', function () {
				jQuery.ajax({
					url : attributeDefinitionsURL,
					dataType : 'json',
					accepts : {
						json: "application/json"
					},
					success : function (response) {
						var error;

						// check if the returned data is an array and check first entry for ID attribute
						if (! (response instanceof Array && response[0].hasOwnProperty("ID"))) {
							error = new Error(ErrorType.NON_RECOVERABLE, Strings.get_attribute_definitions_failed, Strings.invalid_attribute_definitions);
							callLog(_name, Strings.get_attribute_definitions_failed, error, 'GET_ATTRIBUTE_DEFINITIONS_FAILED', errorCallbacks);
							return;
						}

						_attributeDefinitions = response;

						callLog(_name, Strings.get_attribute_definitions_succeeded, _attributeDefinitions, 'GET_ATTRIBUTE_DEFINITIONS_SUCCEEDED', callbacks);
					},
					error : function (jqXHR) {
						var error = new Error(ErrorType.NON_RECOVERABLE, Strings.get_attribute_definitions_failed, Util.toString(jqXHR));

						callLog(_name, Strings.get_attribute_definitions_failed, error, 'GET_ATTRIBUTE_DEFINITIONS_FAILED', errorCallbacks);
					}
				});
			});
		};

		this.keyword = function (attributeId, fallbackToId) {
			var attribute = getAttribute(attributeId);

			if (attribute !== null && Util.isValidString(attribute['ID'])) {
				return attribute['ID'];
			}

			return (fallbackToId ? attributeId : null);
		};

		this.name = function (attributeId, fallbackToId) {
			var attribute = getAttribute(attributeId);

			if (attribute !== null && Util.isValidString(attribute['FriendlyName'][0]['value'])) {
				return attribute['FriendlyName'][0]['value'];
			}

			return (fallbackToId ? attributeId : attribute);
		};

//		this.description = function (attributeId) {
//			var attribute = getAttribute(attributeId);
//
//			if (attribute !== null && Util.isValidString(attribute['Description'][0]['value'])) {
//				return attribute['Description'][0]['value'];
//			}
//
//			return attribute;
//		};

		this.sortAttributes = function (attributes) {
			var that = this;
                        
			attributes.sort(function (a, b) {
				var aName = (a instanceof Attribute) ? a.name() : a;
				var bName = (b instanceof Attribute) ? b.name() : b;
				return _attributeOrder.indexOf(that.keyword(aName)) -
						_attributeOrder.indexOf(that.keyword(bName));
			});

			return attributes;
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/AttributesManager.js
// module id = 96
// module chunks = 4